"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.msToMMSS = exports.msToHHMM = void 0;
var msToHHMM = function (ms) {
    // 1- Convert to seconds:
    var seconds = ms / 1000;
    // 2- Extract hours:
    var hours = parseInt("".concat(seconds / 3600)); // 3,600 seconds in 1 hour
    seconds = seconds % 3600; // seconds remaining after extracting hours
    // 3- Extract minutes:
    var minutes = parseInt("".concat(seconds / 60)); // 60 seconds in 1 minute
    // 4- Keep only seconds not extracted to minutes:
    seconds = seconds % 60;
    return hours + ":" + (minutes < 10 ? "0".concat(minutes) : minutes);
};
exports.msToHHMM = msToHHMM;
var msToMMSS = function (ms) {
    // 1- Convert to seconds:
    var seconds = ms / 1000;
    // 2- Extract hours:
    var hours = parseInt("".concat(seconds / 3600)); // 3,600 seconds in 1 hour
    seconds = seconds % 3600; // seconds remaining after extracting hours
    // 3- Extract minutes:
    var minutes = parseInt("".concat(seconds / 60)); // 60 seconds in 1 minute
    // 4- Keep only seconds not extracted to minutes:
    seconds = seconds % 60;
    return "".concat(minutes, ":").concat(seconds < 10 ? "0".concat(seconds) : seconds);
};
exports.msToMMSS = msToMMSS;
